// extracted by mini-css-extract-plugin
module.exports = {"myorder":"MyOrder_main_style_myorder__2exez","myorderTit":"MyOrder_main_style_myorderTit__4ueA-","myorderBox":"MyOrder_main_style_myorderBox__2dF35"};